﻿
export default class InputFloatLabel {

    constructor() {
        this.inputSelector = '.vti__input, .input--float-label';
        this.parentSelector = '.form-group--float-label';
        this.floatClass = 'float-active';

    }

    Init() {
        var model = this;

        $(model.inputSelector).each(function (index) {
            if ($(this).val()) {
                $(this).closest(model.parentSelector).addClass(model.floatClass);
            }
        });


        // handle late load of value or programatic value change
        $(document).on('change', model.inputSelector, function (event) {        
            if (!$(this).val()) {
                $(this).closest(model.parentSelector).removeClass(model.floatClass);
            }
            else {
                $(this).closest(model.parentSelector).addClass(model.floatClass);
            }

  
        });

        //handle focus
        $(document).on('focus', model.inputSelector, function (event) {  
                $(this).closest(model.parentSelector).addClass(model.floatClass); 

        
        });
        
       

        $(document).on('focusout', model.inputSelector, function (event) {        
            if (!$(this).val()) {
                $(this).closest(model.parentSelector).removeClass(model.floatClass);
            }

           
        });
    }

    static Rebind() {
        var inputSelector = '.vti__input, .input--float-label';
        var parentSelector = '.form-group--float-label';
        var floatClass = 'float-active';

        $(inputSelector).each(function (index) {
            if ($(this).val()) {
                $(this).closest(parentSelector).addClass(floatClass);
            }
            else {
                $(this).closest(parentSelector).removeClass(floatClass);
            }
        });
    }
}

$(document).ready(function () {
    var inputFloatLabel = new InputFloatLabel();
    inputFloatLabel.Init();
});
